import React from "react";
import Header from "./Header";
import styled from "styled-components";
import { color } from "../Utils/Constant";
import Body from "./Body";

// styles
const Wrapper = styled.div`
  background-color: ${color.white};
  width: 380px;
  /* padding: 10px; */
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.4);

  @media (max-width: 786px) {
    width: 100%;
    box-shadow: none;
  }
`;

const MainPage = () => {
  return (
    <Wrapper>
      {/* header section */}
      <Header />
      {/* Main content */}
      <Body/>
    </Wrapper>
  );
};

export default MainPage;
